import { render, staticRenderFns } from "./claimInfo.vue?vue&type=template&id=3cbcf51e&scoped=true"
import script from "./claimInfo.vue?vue&type=script&lang=js"
export * from "./claimInfo.vue?vue&type=script&lang=js"
import style0 from "./claimInfo.vue?vue&type=style&index=0&id=3cbcf51e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbcf51e",
  null
  
)

export default component.exports